import styles from './signUp.module.scss';

export const SignUpComponent = () => {
  return (
    <div className={`${styles.signUpComponent}`}>
      <h2 className={`${styles.loginComponentTitle}`}>Create an account</h2>
    </div>
  );
};
